import { useState } from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

const CertificateData={
  HTML5:"https://lh3.googleusercontent.com/d/1ei1KCcqJRklFavQqCpMygAVH6YjY-yGG",
  htmlSololearn:"https://lh3.googleusercontent.com/d/11TL8j1iV8UsMPFXxQ2qrw6iPRj5yl_6e",
  CSS3:"https://lh3.googleusercontent.com/d/1YeL2LCk--c1pXSjMXAlt8ycD_VH40htF",
  cssSololearn:"https://lh3.googleusercontent.com/d/1w8cbGVD8baFr6g_Ml5kPKu03KLv362FW",
  JAVASCRIPT:"https://lh3.googleusercontent.com/d/1KafNdlGKnCnyWbsKepdAlhDDYv_XTHo-",
  JavaLanguage:"https://lh3.googleusercontent.com/d/1mX0MpW7LT3FDM_ni0I2_ryZfAMPk-8yN",
  JavaFundamental:"https://lh3.googleusercontent.com/d/1xo9M4HBJfPhgihHNejYSBWe031PgSsgS",
  SE8Java:"https://lh3.googleusercontent.com/d/1GUwxZ4i94nf83FmmZm9hcxu_FpJSizsT",
  Python:"https://lh3.googleusercontent.com/d/1hNAqPC5eM6ivgA1JD65A2_Vh-7xQ4tQw",
  PythonCore:"https://lh3.googleusercontent.com/d/12rFztHjNBxRM4PBdRlCth0du8YFJEJxx",
  LanguageC:"https://lh3.googleusercontent.com/d/1hTPLCVPUbl9rqHGwmg6iR8kcA92tfRpR",
  SparkAR:"https://lh3.googleusercontent.com/d/1RkuvhdxOMbyeAWf9lu0Rt__XlGXgZ-FS",
  Hackathon:"https://lh3.googleusercontent.com/d/1j3Z-NKasZh6qoWNJKOrNIU3PXq2b2jDz",
  Hackathon2:"https://lh3.googleusercontent.com/d/1EOKe8mxqDD0FLMeyGo9LPCSEyoyzl2oN"
}

const MyCertificateHome = ({ darkMode }) => {
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [isAnimationPaused, setIsAnimationPaused] = useState(false);

  const certificates = [
    { id: 1, title: "HTML5", image: CertificateData.HTML5 },
    { id: 2, title: "HTML Sololearn", image: CertificateData.htmlSololearn },
    { id: 3, title: "CSS3", image: CertificateData.CSS3 },
    { id: 4, title: "CSS Sololearn", image: CertificateData.cssSololearn },
    { id: 5, title: "JavaScript", image: CertificateData.JAVASCRIPT },
    { id: 6, title: "Java Language", image: CertificateData.JavaLanguage },
    { id: 7, title: "Java Fundamental", image: CertificateData.JavaFundamental },
    { id: 8, title: "SE8 Java", image: CertificateData.SE8Java },
    { id: 9, title: "Python", image: CertificateData.Python },
    { id: 10, title: "Python Core", image: CertificateData.PythonCore },
    { id: 11, title: "C Language", image: CertificateData.LanguageC },
    { id: 12, title: "Spark AR", image: CertificateData.SparkAR },
    { id: 14, title: "Hackathon Participation", image: CertificateData.Hackathon },
    { id: 15, title: "Hackathon 2", image: CertificateData.Hackathon2 }
  ];

  const handleCertificateClick = (certificate) => {
    if (!isAnimationPaused) setIsAnimationPaused(true);
    const index = certificates.findIndex((c) => c.id === certificate.id);
    setCurrentIndex(index >= 0 ? index : 0);
    setSelectedCertificate(certificate);
  };

  const totalCertificates = certificates.length;
  const goPrev = () => {
    if (currentIndex === null) return;
    const newIndex = (currentIndex - 1 + totalCertificates) % totalCertificates;
    setCurrentIndex(newIndex);
    setSelectedCertificate(certificates[newIndex]);
  };

  const goNext = () => {
    if (currentIndex === null) return;
    const newIndex = (currentIndex + 1) % totalCertificates;
    setCurrentIndex(newIndex);
    setSelectedCertificate(certificates[newIndex]);
  };

  return (
    <div className="relative overflow-hidden">
      {/* Certificates Section */}
      <section className="relative lg:w-[85%] w-full mx-auto ">
        {/* Background decorative blobs */}
        <div className="absolute inset-0 -z-10 pointer-events-none">
          <div className={`absolute top-10 left-0 w-72 h-72 ${darkMode ? 'bg-blue-500/10' : 'bg-blue-300/20'} rounded-full blur-3xl animate-pulse`}></div>
          <div className={`absolute bottom-0 right-0 w-96 h-96 ${darkMode ? 'bg-purple-500/10' : 'bg-purple-300/20'} rounded-full blur-3xl animate-pulse delay-1000`}></div>
          <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] ${darkMode ? 'bg-gradient-to-r from-blue-500/5 to-purple-500/5' : 'bg-gradient-to-r from-blue-200/20 to-purple-200/20'} rounded-full blur-3xl`}></div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <div className="relative ">
            <h1 className={`text-center w-full lg:w-full text-3xl font-extrabold py-3 
                    ${darkMode ?
                "bg-gradient-to-r from-gray-200 to-gray-500 text-transparent bg-clip-text"
                : "bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text"
              }
                    before:content-[''] before:absolute before:left-1/2 before:-translate-x-1/2 
                    before:bottom-0.5 before:w-24 before:h-1 
                    ${darkMode ? "before:bg-gray-400" : "before:bg-blue-600"}
                    before:rounded-full`}
            >
              Certificates
            </h1>
            <div className={`absolute -z-10 top-0 left-1/2 -translate-x-1/2 w-48 h-48 
                    ${darkMode ? "bg-gray-700" : "bg-blue-200"} 
                    rounded-full blur-[80px] opacity-50`}>
            </div>
          </div>
          <p className={`${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>My Achievements & Certifications</p>
        </motion.div>
        <div className={`relative w-full h-full rounded-lg`}>
          <div className={`relative rounded-2xl p-2 ${darkMode ? 'bg-gray-800/40 border border-gray-700' : 'bg-transparent  border border-gray-900/45'} shadow-xl`}>
            {/* First Row - Right to Left */}
            <div className="relative rounded-xl w-full h-[170px] mb-8 overflow-hidden">
              <motion.div
                initial={{ x: 0 }}
                animate={{ x: "-50%" }}
                transition={{
                  duration: 80,
                  repeat: Infinity,
                  ease: "linear",
                  repeatType: "loop",
                  paused: isAnimationPaused
                }}
                className="flex gap-4 rotate-3 absolute whitespace-nowrap"
              >
                {[...certificates, ...certificates].map((cert, index) => (
                  <motion.div
                    key={`row1-${cert.id}-${index}`}
                    whileHover={{ scale: 1.05 }}
                    className="min-w-[270px] h-[170px] relative cursor-pointer"
                    onClick={() => handleCertificateClick(cert)}
                  >
                    <img
                      src={cert.image}
                      alt={cert.title}
                      className={`w-full h-full object-cover rounded-lg shadow-md hover:shadow-lg transition-all duration-300 ${darkMode ? 'opacity-90' : 'opacity-100'}`}
                    />
                    <p className="absolute text-xs bottom-2 left-2 text-white bg-black/50 px-2 py-1 rounded">
                      {cert.title}
                    </p>
                  </motion.div>
                ))}
              </motion.div>
            </div>

            {/* Second Row - Left to Right */}
            <div className="relative rounded-xl w-full h-[170px] overflow-hidden">
              <motion.div
                initial={{ x: "-50%" }}
                animate={{ x: 0 }}
                transition={{
                  duration: 80,
                  repeat: Infinity,
                  ease: "linear",
                  repeatType: "loop",
                  paused: isAnimationPaused
                }}
                className="flex gap-4 absolute whitespace-nowrap"
              >
                {[...certificates, ...certificates].map((cert, index) => (
                  <motion.div
                    key={`row2-${cert.id}-${index}`}
                    whileHover={{ scale: 1.05 }}
                    className="min-w-[270px] h-[170px] relative cursor-pointer"
                    onClick={() => handleCertificateClick(cert)}
                  >
                    <img
                      src={cert.image}
                      alt={cert.title}
                      className={`w-full h-full object-cover rounded-lg shadow-md duration-300 ${darkMode ? 'opacity-90' : 'opacity-100'}`}
                    />
                    <p className="absolute text-xs bottom-2 left-2 text-white bg-black/50 px-2 py-1 rounded">
                      {cert.title}
                    </p>
                  </motion.div>
                ))}
              </motion.div>
            </div>
          </div>
        </div>
        {/* Certificate Preview Modal */}
        {selectedCertificate && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 p-12 bg-black/90 z-50 rounded-lg flex items-center justify-center"

          >

            <div className="lg:max-w-[95vw] lg:max-h-[90vh] w-full flex items-center justify-center" onClick={e => e.stopPropagation()}>
              <div className=' bottom-0 left-0 w-full absolute rounded-t-lg'>
                <div className='flex justify-between lg:justify-center py-2 px-4  items-center'>
                  {/* Counter */}
                  {currentIndex !== null && (
                    <div className="absolute bottom-7 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full text-xs font-medium bg-gradient-to-r from-blue-600 to-purple-600 text-white backdrop-blur-sm">
                      {currentIndex + 1}/{totalCertificates}
                    </div>
                  )}

                  {/* Left Button */}
                  <button
                    aria-label="Previous"
                    onClick={goPrev}
                    className=" h-10 w-10 md:h-12 md:w-12 lg:mr-6 rounded-full text-lg bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg hover:shadow-xl flex items-center justify-center"
                  >
                    ‹
                  </button>
                  {/* Right Button */}
                  <button
                    aria-label="Next"
                    onClick={goNext}
                    className="h-10 w-10 md:h-12 md:w-12 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg hover:shadow-xl flex items-center justify-center"
                  >
                    ›
                  </button>
                </div>
              </div>
              {/* Image */}
              <img
                src={selectedCertificate.image}
                alt={selectedCertificate.title}
                className="lg:max-w-[90vw] lg:max-h-[60vh] object-contain shadow-2xl rounded-md border border-white/10"
              />



              {/* Close */}
              <button
                className="absolute top-4 right-4 text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 px-4 py-2 rounded-md"
                onClick={() => { setSelectedCertificate(null); setCurrentIndex(null); }}
              >
                ✕
              </button>
            </div>

          </motion.div>
        )}
      </section>
    </div>
  );
};

MyCertificateHome.propTypes = {
  darkMode: PropTypes.bool.isRequired,
};

export default MyCertificateHome;
